
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Zap } from "lucide-react";

interface ModalHeaderProps {
  setIndex: number;
}

export const ModalHeader = ({ setIndex }: ModalHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle className="text-white flex items-center gap-2">
        <Zap className="h-4 w-4 text-yellow-400" />
        Editar Serie {setIndex + 1}
      </DialogTitle>
    </DialogHeader>
  );
};
